import { tag } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetExternalAccounts = gql`
  query GetExternalAccountsR2 {
    myAccounts {
      id
      internal {
        id
      }
      external {
        __typename
        id
        type
        status
        institution {
          name
        }
        iconUrl
        product
        accountNumber
        accountNumberLast4
        ... on ExternalAccount {
          previewBalance {
            __typename
            amount
            currency
            formatted
            formattedWithPlusPrefix
          }
          tag {
            ...tag
          }
        }
        ... on ExternalPlaidAccount {
          currentBalance {
            amount
            formatted
          }
          tag {
            ...tag
          }
        }
      }
    }
  }
  ${tag}
`;

export default GetExternalAccounts;
